module.exports = __webpack_public_path__ + "img/3.0442bd02.png";